export { default } from './refType';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/refType/index.js
// module id = 45
// module chunks = 22